export default __webpack_public_path__ + "static/media/Image1Desktop.c0d7af4d.png";